var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "question" }, [
    _c("div", { staticClass: "form-label" }, [
      _c("label", { staticClass: "text", attrs: { for: _vm.item.data.id } }, [
        _vm._v(_vm._s(_vm.item.data.question)),
      ]),
      _vm._v(" "),
      _vm.item.data.question && _vm.item.data.mandatory
        ? _c("span", { staticClass: "mandatory" }, [_vm._v("*")])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "mandatory_warning", staticStyle: { display: "none" } },
      [_vm._v(_vm._s(_vm.item.data.mandatory_warning))]
    ),
    _vm._v(" "),
    _c(
      "label",
      { staticClass: "customerrormessage", staticStyle: { display: "none" } },
      [_vm._v(_vm._s(_vm.item.data.customerrormessage))]
    ),
    _vm._v(" "),
    _vm.item.data.description && _vm.item.data.description !== ""
      ? _c("div", { staticClass: "form-text" }, [
          _c("p", [_vm._v(_vm._s(_vm.item.data.description))]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }